/* eslint-disable angular/document-service */
class FontSignatureController {
  constructor($scope) {
    'ngInject';
    this.signatureText = '';
    this.fontIncrease = 0;
    this.lastFontSize = 0;
    this.minFontSize = 20;
    this.maxFontSize = 100;
    $scope.$watch('$ctrl.fontSignature', () => { this.clearText() });
  }

  $onInit() {
    this.canvas = $("#font-canvas")[0];
    this.initialFontSize = this.height * 0.9;
    this.maxFontSize = this.height * 3;
    this.lastFontSize = this.initialFontSize;
    this.startFontSize = 0;
    this.hasData = false;
  }

  updateSignature() {
    const ctx = this.canvas.getContext("2d");
    const font = this.font || "'Pinyon Script'";

    ctx.fillStyle = this.color;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    if (!this.signatureText.length) {
      this.fontIncrease = 0;
      this.lastFontSize = this.initialFontSize;
      this.startFontSize = 0;
    }

    let fontSize = this.startFontSize || this.initialFontSize;
    const lineHeightMult = 1.15;
    const textHeightMult = 1.2;
    const maxWidth = this.canvas.width * 0.9;
    const xCenter = this.canvas.width / 2;
    let yCenter = this.canvas.height / 2;
    let lineHeight = fontSize * lineHeightMult;

    do {
      ctx.font = fontSize + "px " + font;
      const measure = ctx.measureText(this.signatureText);
      const textWidth = measure.width;
      const textHeight = fontSize * textHeightMult;
      if (textWidth <= maxWidth && textHeight <= this.canvas.height) break;
      fontSize--;
      lineHeight = fontSize * lineHeightMult;
    } while (fontSize > 0);
    this.startFontSize = fontSize;

    yCenter += (lineHeight - fontSize) / 2;
    fontSize = Math.max(fontSize + this.fontIncrease, 5);
    ctx.font = fontSize + "px " + font;
    this.lastFontSize = fontSize;

    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    ctx.fillText(this.signatureText, xCenter, yCenter);
    this.dataurl = this.canvas.toDataURL();
    this.hasData = this.signatureText.trim().length;
  }

  changeFontSize(amount) {
    if (amount < 0 && this.lastFontSize <= this.minFontSize) return;
    if (amount > 0 && this.lastFontSize >= this.maxFontSize) return;
    const change = (this.lastFontSize / 10);
    this.fontIncrease += amount * change;
    this.updateSignature();

  }
  clearText() {
    this.signatureText = "";
    this.fontIncrease = 0;
    this.startFontSize = 0;
    this.updateSignature();
  }
  toggleFontSignature() {
    this.fontSignature = false;
  }
}

export default {
  templateUrl: 'fe-control/modals/signature/font-signature/font-signature.component.html',
  bindings:{
    'hasData': '=',
    'fontSignature': '=',
    'height': '=?',
    'width': '=?',
    'color': '=?',
    'font': '=?',
    'dataurl': '=?'
  },
  controller: FontSignatureController
};
